import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import MobileBottomNav from './MobileBottomNav';

const Layout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Pages qui doivent afficher le header principal
  const pagesWithHeader = ['/dashboard'];
  const showHeader = pagesWithHeader.includes(location.pathname);

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  // Récupérer le nom de l'utilisateur depuis le localStorage
  const userName = localStorage.getItem('userName') || localStorage.getItem('userEmail')?.split('@')[0] || 'Utilisateur';

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header conditionnel - seulement sur desktop */}
      {showHeader && (
        <header className="bg-white shadow flex-shrink-0 hidden md:block">
          <div className="max-w-7xl mx-auto py-4 px-4 sm:px-6 lg:px-8 flex justify-between items-center">
            <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">Mes Prix</h1>
            <div className="flex items-center">
              <span className="mr-2 sm:mr-4 text-sm sm:text-base text-gray-700 hidden sm:inline">
                Bonjour, {userName}
              </span>
              <button
                onClick={handleLogout}
                className="inline-flex items-center px-3 py-2 sm:px-4 border border-transparent text-xs sm:text-sm font-medium rounded-md shadow-sm text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
              >
                Déconnexion
              </button>
            </div>
          </div>
        </header>
      )}
      
      {/* Contenu principal */}
      <div className="pb-16 md:pb-0">
        {children}
      </div>
      
      {/* Barre de navigation mobile */}
      <MobileBottomNav />
    </div>
  );
};

export default Layout; 